// OpenAI API Client
// https://platform.openai.com/docs/api-reference

import { createRequestAPI } from './utils.js'

/**
 * Create OpenAI client
 * @param {Function} httpRequest - HTTP request function
 * @returns {Object} OpenAI client with chatCompletions, listModels, retrieveModel
 */
export function createOpenaiClient(httpRequest) {
  const requestAPI = createRequestAPI(httpRequest)

  // https://platform.openai.com/docs/api-reference/chat/create
  const chatCompletions = async ({
    apiKey,
    model = 'gpt-4',
    messages,
    temperature,
    max_tokens,
    top_p,
    frequency_penalty,
    presence_penalty,
    stream = false,
    stop,
    n,
    user,
    tools,
    tool_choice,
  }) => {
    if (!messages || !Array.isArray(messages) || messages.length === 0) {
      throw new Error('messages is required and must be a non-empty array')
    }

    const bodyParams = {
      model,
      messages,
      temperature,
      max_tokens,
      top_p,
      frequency_penalty,
      presence_penalty,
      stream,
      stop,
      n,
      user,
      tools,
      tool_choice,
    }

    const body = Object.fromEntries(
      Object.entries(bodyParams).filter(([_, value]) => value !== undefined),
    )

    return await requestAPI({
      path: '/v1/chat/completions',
      method: 'POST',
      apiKey,
      body,
    })
  }

  // https://platform.openai.com/docs/api-reference/models/list
  const listModels = async ({ apiKey }) => {
    return await requestAPI({
      path: '/v1/models',
      method: 'GET',
      apiKey,
      body: {},
    })
  }

  // https://platform.openai.com/docs/api-reference/models/retrieve
  const retrieveModel = async ({ apiKey, model }) => {
    if (!model) {
      throw new Error('model is required')
    }

    return await requestAPI({
      path: `/v1/models/${model}`,
      method: 'GET',
      apiKey,
      body: {},
    })
  }

  return {
    chatCompletions,
    listModels,
    retrieveModel,
  }
}
